import { NextPageContext } from 'next'
import { NextIncomingMessage } from 'next/dist/server/request-meta'

import { TOPBAR_ENDPOINT, TOPBAR_INTERNAL_DATA } from './constants'
import getQueryArgs from './get-query-args'
import { TopbarData, TopbarOptions } from './types'

const IS_CI = process.env.CI || process.env.NEXT_PUBLIC_CI

async function fetchTopbar(
  req: NextIncomingMessage,
  options?: TopbarOptions
): Promise<TopbarData | null> {
  if (process.env.TOPBAR_DISABLED) {
    if (!IS_CI) {
      console.warn('TOPBAR_DISABLED detected. Topbar was disabled')
    }
    return { disabled: true }
  }

  const queryArgs = getQueryArgs(options)
  const xRequestUrl = `https://${req.headers.host}${req.url}`
  try {
    const topbar = await (
      await fetch(`${TOPBAR_ENDPOINT}${queryArgs}`, {
        headers: {
          cookie: req.headers.cookie || '',
          'user-agent': req.headers['user-agent'] || '',
          'x-request-url': xRequestUrl,
        },
      })
    ).json()
    return topbar
  } catch (err) {
    console.error(err)
  }
  return null
}

export async function withTopbarProps(ctx: Pick<NextPageContext, 'req'>, options?: TopbarOptions) {
  const { req } = ctx
  if (!req) {
    console.warn(
      'No request detected, withTopbarProps expects to be used on pages with getServerSideProps, even if setup on ' +
        'custom documents getInitialProps. Topbar was disabled.'
    )
    return {
      [TOPBAR_INTERNAL_DATA]: { disabled: true },
    }
  }
  const data = await fetchTopbar(req, options)
  return {
    [TOPBAR_INTERNAL_DATA]: data,
  }
}
